exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-25b72f2e] .md-checkbox-container {\n  top: 10px;\n}\n[data-v-25b72f2e] .md-checkbox-label {\n  opacity: 1 !important;\n  color: black !important;\n}\n[data-v-25b72f2e] div.md-field.no-underline:after {\n  height: 0px;\n}\n[data-v-25b72f2e] .md-checkbox {\n  margin-top: 0px;\n}\n", ""]);

// exports
